import {
  SnapchatAddToCartParams,
  SnapchatEventNames,
  SnapchatPurchaseParams,
  SnapchatStartCheckoutParams,
  SnapchatViewContentParams,
} from '../../entities';
import { AppnebulaSnapchatService, SnapchatService } from '../../interfaces/SnapchatService';

export class AppnebulaHttpSnapchatService implements AppnebulaSnapchatService {
  constructor(private readonly snapchatService: SnapchatService) {}

  pageView() {
    this.snapchatService.track(SnapchatEventNames.PAGE_VIEW);
  }

  signUp(email: string, userId: string) {
    this.snapchatService.track(SnapchatEventNames.SIGN_UP, {
      user_email: email,
      sign_up_method: 'email',
      client_dedup_id: userId,
    });

    this.snapchatService.updateUserData({
      user_email: email,
    });
  }

  viewContent({ items, currency, nebulaId }: SnapchatViewContentParams) {
    this.snapchatService.track(SnapchatEventNames.VIEW_CONTENT, {
      client_dedup_id: nebulaId,
      currency,
      content_ids: items.map((item) => item.productId),
      contents: items.map((item) => ({
        id: item.productId,
        item_price: item.price,
      })),
    });
  }

  addToCart({ productId, price, currency, nebulaId }: SnapchatAddToCartParams) {
    this.snapchatService.track(SnapchatEventNames.ADD_CART, {
      client_dedup_id: nebulaId,
      currency,
      value: price,
      number_items: 1,
      content_ids: [productId],
      contents: [{ id: productId, item_price: price }],
    });
  }

  startCheckout({ productId, price, currency, nebulaId }: SnapchatStartCheckoutParams) {
    this.snapchatService.track(SnapchatEventNames.START_CHECKOUT, {
      client_dedup_id: nebulaId,
      currency,
      value: price,
      number_items: 1,
      content_ids: [productId],
      contents: [{ id: productId, item_price: price }],
    });
  }

  purchase({ price, ltvPredict, paymentId, currency, productId }: SnapchatPurchaseParams) {
    this.snapchatService.track(SnapchatEventNames.PURCHASE, {
      transaction_id: paymentId,
      client_dedup_id: paymentId,
      currency,
      value: ltvPredict,
      number_items: 1,
      content_ids: [productId],
      contents: [{ id: productId, item_price: price }],
    });
  }
}
